import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {normalize, isApiResponseOk} from '../../util/utils';
import Utility from '../../util/utilityfunctions';

export function itcontrolDetailsReducer(state = initialstate.controlsDetails, action) {
	switch (action.type) {
		case types.GET_ITCONTROL_BY_ID: {
			if (action.response) {
				// Build relatedITRisks including their related itProcesses from response.relatedITProcesses
				const relatedITProcesses = action.response.relatedITProcesses || [];
				const relatedITRisks = (action.response.relatedITRisks || []).map((risk) => {
					const itProcessesForRisk = relatedITProcesses.filter((p) => risk.itRiskID === p.itRiskId);
					return {
						...risk,
						relatedITProcesses: itProcessesForRisk
					};
				});

				return {
					...action.response,
					relatedITRisks
				};
			} else {
				return state;
			}
		}
		case types.UPDATE_ITRISK_ITCONTROL: {
			if (!action.payload) {
				return state;
			}
			return updateRelatedITRiskITControls(state, action);
		}
		case types.RELATE_ITRISK_ITCONTROL_UPDATE_CONTROL: {
			if (!isApiResponseOk(action) || !action.payload) {
				return state;
			}
			return updateRelatedITRiskITControls(state, action);
		}
		case types.UNRELATE_ITRISK_ITCONTROL_UPDATE_CONTROL: {
			if (!isApiResponseOk(action) || !action.payload) {
				return state;
			}
			return {
				...state,
				relatedITRisks: (state.relatedITRisks || []).filter((risk) => risk.itRiskID !== action.payload.relatedITRisks.itRiskID)
			};
		}
		default:
			return state;
	}
}

const updateRelatedITRiskITControls = (state, action) => {
	const newRisk = action.payload.relatedITRisks || {};
	const newApplications = action.payload.relatedITApplications || [];
	const newProcesses = action.payload.relatedITProcesses || [];
	const replaceRiskNameAndApplications = action.payload.replaceRiskNameAndApplications ?? false;
	let updatedRisks = [...(state.relatedITRisks || [])];
	const existingRiskIndex = updatedRisks.findIndex((risk) => risk.itRiskID === newRisk.itRiskID);

	if (existingRiskIndex !== -1) {
		const existingRisk = updatedRisks[existingRiskIndex];
		const mergedApplications = replaceRiskNameAndApplications
			? newApplications
			: [
					...existingRisk.relatedITApplications,
					...newApplications.filter((app) => !existingRisk.relatedITApplications.some((existingApp) => existingApp.itApplicationID === app.itApplicationID))
				];
		const mergedProcesses = [
			...(existingRisk.relatedITProcesses || []),
			...newProcesses.filter((proc) => !(existingRisk.relatedITProcesses || []).some((existingProc) => existingProc.itProcessId === proc.itProcessId))
		];

		updatedRisks[existingRiskIndex] = {
			...existingRisk,
			itRiskName: replaceRiskNameAndApplications ? newRisk.itRiskName : existingRisk.itRiskName,
			relatedITApplications: mergedApplications,
			relatedITProcesses: mergedProcesses
		};
	} else {
		updatedRisks.push({
			...newRisk,
			relatedITApplications: newApplications,
			relatedITProcesses: newProcesses
		});
	}

	return {
		...state,
		relatedITRisks: Utility.cfAlphanumSort(updatedRisks, 'itRiskName')
	};
};

export function itcontrolreducer(state = initialstate.itControls, action) {
	switch (action.type) {
		case types.GET_ITCONTROLS: {
			if (action.response && action.response.data) {
				let newState = {...state};

				const itControlList = normalize(action.response.data.map((itcontrol) => itcontrol));
				itControlList.pages = action.response?.pages;
				itControlList.page = action.response?.page;
				itControlList.totalEntityCount = action.response.totalEntityCount;

				newState = {...itControlList};
				return newState;
			} else {
				return state;
			}
		}
		default:
			return state;
	}
}
